import React from 'react';
import {Route} from 'react-router-dom';
import AsyncList from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
export default (
  <Route
    key="/business/videos"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Videos List',
            item: '/business/videos',
          },
        ]}
      />
    }
  >
    <Route path="business/videos" element={<AsyncList />} />
  </Route>
);
